export enum AddonsType {
  Api = 'api',
  Records = 'records',
  Storage = 'storage',
  Transactions = 'transactions',
  Default = 'none'
}
